module.exports = __webpack_public_path__ + "static/THANK YOU-04ad672dd54bf04d600dbd59566767ee.jpg";